<div class="assign-to-modal">
    <Modal
        id="assign-to-modal-participants-id"
        bind:enabled={enabled}
        cancelText={participantsCancelText}
        confirmText={participantsConfirmText}
        scrollBody={true}
        {titleText}
        on:confirm={handleParticipantsConfirm}
        on:cancel={handleParticipantsCancel}
        on:close={handleClose}
    >
        <div slot="banner">
            <AssignToModalBanner
             showDefaultBanner={!isFolderForPlanCreated}
             />
        </div>
        <div slot="body">
            <AssignToModalTabs {isFirstLoad} {participants} {groups}/>
        </div>
    </Modal>

    <Modal
        id="assign-to-modal-resource-information-id"
        bind:enabled={showResourceInformation}
        cancelText={resourceInformationCancelText}
        confirmText={resourceInformationConfirmText}
        scrollBody={true}
        {titleText}
        on:confirm={handleResourceInformationConfirm}
        on:cancel={handleResourceInformationCancel}
    >
        <div slot="body">{i18n.assignToTerms.assigningPlanCreatesNewFolder}</div>
    </Modal>
</div>

<script>
    import Modal from "@itslearning/prometheus/assets/modals/Modal/v2/Modal.svelte";
    import i18n from "@its-ui/planner-common/i18n";
    import AssignToModalBanner from "./AssignToModalBanner.svelte";
    import AssignToModalTabs from "./Tabs/AssignToModalTabs.svelte";
    import { assignPlan, getPlan } from "../../../api";
    import config from "../../../config";
    import { createEventDispatcher } from 'svelte';

    export let participantsCancelText = i18n.cancel;
    export let participantsConfirmText = i18n.saveParticipants;
    export let resourceInformationCancelText = i18n.cancel;
    export let resourceInformationConfirmText = i18n.assignToTerms.updateAndAssign;
    export let enabled = false;
    export let isFirstLoad = false;
    export let titleText = i18n.assignTo;
    export let isFolderForPlanCreated = false;
    export let plan = null;

    export let participants;
    export let groups;
    
    let showResourceInformation = false;
    let participantIds;
    let groupIds;

    const topicId = plan?.topic?.id ?? 0;
    const dispatch = createEventDispatcher();

    const handleParticipantsConfirm = async () => {
        participantIds = participants.entityArray.filter((item) => item.isAssigned).map((item) => item.personId);
        groupIds = groups.entityArray.filter((item) => item.isAssigned).map((item) => item.groupId);
        
        if (isFolderForPlanCreated) {
            handleAssignTo();
        } else {
            showResourceInformation = true;
        }
    };

    const handleParticipantsCancel = () => {
        showResourceInformation = false;
        dispatch('assignToModalCancelled');
    };

    const handleResourceInformationConfirm = async () => {
        handleAssignTo();
    };

    const handleResourceInformationCancel = () => {
        showResourceInformation = false;
        dispatch('assignToModalCancelled');
    };

    const handleAssignTo = async () => {
        const result = await assignPlan(config.planId, participantIds, groupIds, topicId);
        const updatedPlan = await getPlan(config.planId);
        const updatedElements = updatedPlan.elements;
        const planFolderUrl = result?.PlanFolderUrl;

        dispatch('assignToModalConfirmed', { updatedElements, planFolderUrl });
    };

    const handleClose = () => {
        dispatch('assignToModalClosed');
    };
</script>
